import React from 'react';
import { Subheader } from 'material-ui';
import typography from 'material-ui/styles/typography';
import { white } from 'material-ui/styles/colors';
import { IconButton } from '@material-ui/core';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import columns from './mrs-approval-columns';
import DataTablePagination from '../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import { Visibility, Search, Add, AssignmentLate } from '@material-ui/icons';
import { injectIntl } from 'react-intl';
import PageBase from '../../../widgets/PageBase/PageBase';
import InfoBox from '../../../widgets/InfoBox/InfoBox';
import { Link } from 'react-router-dom';
import { MRS_CUSTOMERS_URL, MRS_ORDER_SEARCH } from '../../../../route-names';

const mappedColumns = (columns, sortRequest, sortBy, onClick, props) => [
  // Give the column header sort by functions.
  ...columns.map((column) => ({
    ...column,
    header: {
      ...column.header,
      onRequestSort: () =>
        column.header.sortBy ? sortRequest(column.header.sortBy) : () => {},
      isSortedBy: () => sortBy.name === column.header.sortBy
    }
  })),
  // Add column with icon for viewing.
  {
    header: {
      display: ''
    },
    accessor: (order) => {
      return {
        display: (
          <div style={{ float: 'right', textAlign: 'right' }}>
            <IconButton
              className="details-button"
              iconclassname="details-icon material-icons"
              label={props.intl.formatMessage({ id: 'product_details' })}
              onClick={() => (onClick ? onClick(order.mrsOrderId) : null)}
            >
              <Visibility />
            </IconButton>
          </div>
        ),
        ignoreOnClick: true
      };
    }
  }
];

// Give each row an on-click function.
const mappedOrders = (orders, onClick) =>
  orders.map((order) => {
    return {
      ...order,
      onClick: () => (onClick ? onClick(order.mrsOrderId) : null)
    };
  });

const MRSPortalPage = (props) => (
  <PageBase
    navigation={[
      props.intl.formatMessage({
        id: 'nav.mrs_portal'
      })
    ]}
    noWrapContent
    loading={props.loading}
  >
    <div className="main-paper-layout">
      <div className="row info-boxes m-b-15" style={{ maxWidth: 800 }}>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 m-b-15">
          <InfoBox
            icon={
              <AssignmentLate
                style={{ color: '#ecbb43' }}
                className="icon-box-icon-image material-icons"
              />
            }
            color="#F0AB00"
            title={props.intl.formatMessage({
              id: 'requiring_approval.title'
            })}
            value={props.mrsRequiringActionCount}
          />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 m-b-15">
          <Link to={MRS_CUSTOMERS_URL}>
            <InfoBox
              icon={
                <Add
                  style={{ color: '#cb3753' }}
                  className="icon-box-icon-image material-icons"
                />
              }
              color="#003968"
              title={props.intl.formatMessage({
                id: 'create_new_mrs'
              })}
            />
          </Link>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 ">
        <Subheader
          style={{
            fontSize: 24,
            fontWeight: typography.fontWeightLight,
            backgroundColor: '#3e4757',
            color: white,
            margin: '20px 0px 0px 0px'
          }}
        >
          Required Approvals
        </Subheader>
        <DataTable
          columns={mappedColumns(
            columns(props),
            props.handleRequestSort,
            props.sortBy,
            props.handleOrderClick,
            props
          )}
          bodyData={mappedOrders(
            props.mrsOrdersRequiringAction,
            props.handleOrderClick
          )}
          direction={props.sortBy.direction}
          footerContent={
            <DataTablePagination
              page={props.page}
              onChangePage={props.handleChangePage}
              onChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          }
        />
      </div>
    </div>
  </PageBase>
);

export default injectIntl(MRSPortalPage);
